var _g, _path, _path2, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20 -99H294V82.9964C294 86.0922 290.634 88.0146 287.968 86.4416L276.332 79.5777C275.118 78.8619 273.618 78.8372 272.381 79.5126L256.668 88.0976C255.473 88.7505 254.027 88.7505 252.832 88.0976L237.043 79.4713C235.848 78.8183 234.402 78.8183 233.207 79.4713L217.418 88.0976C216.223 88.7505 214.777 88.7505 213.582 88.0976L197.793 79.4713C196.598 78.8183 195.152 78.8183 193.957 79.4713L178.168 88.0976C176.973 88.7505 175.527 88.7505 174.332 88.0976L158.543 79.4713C157.348 78.8183 155.902 78.8183 154.707 79.4713L138.918 88.0976C137.723 88.7505 136.277 88.7505 135.082 88.0976L117.375 78.4235L99.6678 88.0976C98.4726 88.7505 97.0274 88.7505 95.8322 88.0976L80.0428 79.4713C78.8476 78.8183 77.4024 78.8183 76.2072 79.4713L60.4178 88.0976C59.2226 88.7505 57.7774 88.7505 56.5822 88.0976L40.7928 79.4713C39.5976 78.8183 38.1524 78.8183 36.9572 79.4713L21.1678 88.0976C19.9726 88.7505 18.5274 88.7505 17.3322 88.0976L1.61851 79.5126C0.382232 78.8372 -1.1182 78.8619 -2.33158 79.5777L-13.9677 86.4416C-16.6342 88.0146 -20 86.0922 -20 82.9964V-99Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 15.5834C12.4123 15.5834 15.5837 12.412 15.5837 8.50002C15.5837 4.588 12.4123 1.41669 8.50033 1.41669C4.58831 1.41669 1.41699 4.588 1.41699 8.50002C1.41699 12.412 4.58831 15.5834 8.50033 15.5834Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.25V8.5L11.3333 9.91667",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3002.5,
    y: -11603.5,
    width: 5627,
    height: 12373,
    stroke: "white",
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -24,
    y: -101,
    width: 322,
    height: 195.587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ico_clock.540f3e25abc4e89ae60c13e35f835762.svg";
export { ForwardRef as ReactComponent };